import { takeLatest, put, call } from "redux-saga/effects";

import {
  GET_EVENT_DISPLAY_RESULT_FILES,
  ADD_DISPLAY_EVENT_FILE,
  DEL_DISPLAY_EVENT_FILE,
} from "./actionTypes";

import {
  getEventsSuccess,
  getEventsFail,
  addEventSuccess,
  addEventFailure,
  delEventFileSuccess,
  delEventFileFailure,

} from "./actions";

import {
  getEventResultsDisplayFiles,
  addEventResultDisplay,

  delEventResultsDisplayFile,
  getEventResultAttendeesList,

} from "../../helpers/backend_helper";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getEventAttendeeResultsFail, getEventAttendeeResultsSuccess } from "../events/actions";
import { GET_EVENT_ATTENDEE_RESULTS } from "../events/actionTypes";



function* onAddEvent({ payload: data, token, navigate }) {


  try {
    const response = yield call(addEventResultDisplay, data, token);
    
  
    yield put(addEventSuccess(response.data));
  } catch (error) {
    yield put(addEventFailure(error.response));
  }
}

function* onGetEvents({ payload: token }) {


  try {
    const response = yield call(getEventResultsDisplayFiles, token);
 

    yield put(getEventsSuccess(response.data));
  } catch (error) {

    yield put(getEventsFail(error.response));
  }
}

function* onGetEventResultAttendee({ payload: token }) {


  try {
    const response = yield call(getEventResultAttendeesList, token);
 

    yield put(getEventAttendeeResultsSuccess(response.data));
  } catch (error) {

    yield put(getEventAttendeeResultsFail(error.response));
  }
}


function* onDelFile({ payload: data, navigate, token }) {


  try {
    const response = yield call(delEventResultsDisplayFile, data, token);
 
    //toast(response.message);
   
    yield put(delEventFileSuccess(response.data));
  } catch (error) {
    toast(error.response.data.data);
    yield put(delEventFileFailure(error.response));
  }
}









function* EventResultsDisplaySaga() {

  yield takeLatest(GET_EVENT_DISPLAY_RESULT_FILES, onGetEvents);
  yield takeLatest(ADD_DISPLAY_EVENT_FILE, onAddEvent);
   yield takeLatest(DEL_DISPLAY_EVENT_FILE, onDelFile);
   yield takeLatest(GET_EVENT_ATTENDEE_RESULTS ,onGetEventResultAttendee)
  


}

export default EventResultsDisplaySaga;
